import { type PublicGlobalConfig } from '../../../global-config'
import { gtmDataLayerPush } from '../../../gtm'
import {
  urlResolverGetAccount,
  urlResolverGetAccountChangePage,
  urlResolverGetAccountOrders,
  urlResolverGetContactUs,
  urlResolverGetHelpCentrePharmaPage,
  urlResolverGetOrderQuestion,
} from '../../../url-handling'

const getPathNameFromUrl = (url: string): string => {
  if (URL.canParse(url)) {
    return new URL(url).pathname
  }

  return ''
}

export const getContext = ({
  config,
  url,
}: {
  config: PublicGlobalConfig
  url: string
}): string => {
  const referrerPaths = [
    urlResolverGetOrderQuestion(config),
    urlResolverGetHelpCentrePharmaPage(config),
    urlResolverGetAccountChangePage(config),
    urlResolverGetContactUs(config),
  ]

  const pathName = getPathNameFromUrl(url)

  if (pathName === urlResolverGetAccount(config)) {
    return 'account'
  }

  if (pathName === urlResolverGetAccountOrders(config)) {
    return 'order'
  }

  if (referrerPaths.some((path) => url.startsWith(path))) {
    return 'amazonisation'
  }

  return 'other'
}

export const loginRegistrationGtmPushFullStoryPayload = ({
  config,
  isModalOpen,
  pathName,
}: {
  config: PublicGlobalConfig
  isModalOpen?: boolean
  pathName: string
}): void => {
  const referrer = typeof document === 'undefined' ? '' : document.referrer
  const url = isModalOpen ? pathName : referrer

  const context = getContext({ config, url })

  gtmDataLayerPush({
    event: 'fs_page_prop',
    fs_page_properties: {
      context,
      pageName: 'login',
    },
  })
}
